var React = require('react');

function Icons8Delete (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.219 5.781L5.781 7.219 14.563 16l-8.781 8.781 1.438 1.438L16 17.438l8.781 8.781 1.438-1.437L17.438 16l8.781-8.781-1.437-1.437L16 14.563z"}));
}

Icons8Delete.defaultProps = {"viewBox":"0 0 32 32","fill":"#fff","xmlnsV":"https://vecta.io/nano"};

module.exports = Icons8Delete;

Icons8Delete.default = Icons8Delete;
